module.exports = __webpack_public_path__ + "bf2532df/img/boston-lights.a623432f.png";